import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspDashboardService {
  paramData: any;
  constructor( private http: HttpClient,) { }
    getGarageMetrics(garageKey: string, userKey: string, filterWith: string) {

    this.paramData = {
      garageKey: garageKey,
      userKey: userKey,
      filterWith: filterWith
    };

    // console.log('-----Garage Metrics-----------');    

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}` + '/garage/get/metrics',
      this.paramData
    );
  }
}
